import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { can } from "@/lib/permissions";
import { PageHeader, SyntheticBanner } from "@/components/Common";
import { StatusBadge } from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus } from "lucide-react";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const { roleCode } = useApp();
  const nav = useNavigate();
  useEffect(() => { api.orders().then(setOrders).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader testid="orders-header" title="Orders"
        subtitle="All submitted laboratory orders and their current reimbursement-readiness status."
        actions={can.createOrder(roleCode) && (
          <Button data-testid="new-order-btn" className="bg-teal-600 hover:bg-teal-700" onClick={() => nav("/orders/new")}>
            <Plus className="mr-1.5 h-4 w-4" /> New Order
          </Button>
        )} />
      <SyntheticBanner />

      <Card className="overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Order #</TableHead><TableHead>Patient (synthetic)</TableHead>
              <TableHead>Test</TableHead><TableHead>Payer</TableHead>
              <TableHead>Readiness</TableHead><TableHead>Required</TableHead>
              <TableHead>Last relevant test</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.length === 0 && (
              <TableRow><TableCell colSpan={7} className="py-8 text-center text-sm text-slate-500">
                No orders yet. Create one from Order Intake.</TableCell></TableRow>
            )}
            {orders.map((o) => (
              <TableRow key={o.id} data-testid={`order-row-${o.id}`}
                className="cursor-pointer hover:bg-slate-50" onClick={() => nav(`/orders/${o.id}`)}>
                <TableCell className="font-mono text-xs">{o.order_number}</TableCell>
                <TableCell className="font-medium">{o.patient_name}
                  <div className="text-[10px] text-slate-400">{o.synthetic_patient_id}</div></TableCell>
                <TableCell className="text-xs">{o.test_name}</TableCell>
                <TableCell className="text-xs">{o.payer_name}</TableCell>
                <TableCell><StatusBadge status={o.latest_status} size="sm" /></TableCell>
                <TableCell className="font-mono text-xs text-slate-700" data-testid={`order-required-${o.id}`}>
                  {o.required_total ? `${o.required_satisfied}/${o.required_total}` : "—"}</TableCell>
                <TableCell className="text-xs text-slate-600">{o.last_test_date || "Not identified"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
